if(!customElements.get('highlight-features')) {
    customElements.define('highlight-features', class HighlightFeatures extends HTMLElement {
        constructor() {
            super();

            this.querySelector('.highlight-spots').addEventListener('click', (event)=>{
                if(event.target.classList.contains('spot')) {
                    this.handleSpotClick(event.target);
                }
            });

            const boundHandleFeatureClick = this.handleFeatureClick.bind(this);
            this.querySelectorAll('.feature').forEach(feature=>{
                feature.addEventListener('click', boundHandleFeatureClick);
            });

            // Tilt effect — desktop only, and only when enabled via section setting
            if (this.hasAttribute('data-tilt') && window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
                this._image = this.querySelector('.highlight-image');
                this._rafId = null;
                this._mx = 0;
                this._my = 0;

                this._onMouseMove = (e) => {
                    const rect = this.getBoundingClientRect();
                    this._mx = ((e.clientX - rect.left) / rect.width - 0.5) * 2;
                    this._my = ((e.clientY - rect.top) / rect.height - 0.5) * 2;
                    if (this._rafId) return;
                    this._rafId = requestAnimationFrame(() => {
                        this._rafId = null;
                        const max = 10; // 最大倾斜角度（度）
                        const tx = this._mx * 8; // 轻微平移（px），增强晃动感
                        const ty = this._my * 8;
                        this._image.style.transform = `rotateX(${-this._my * max}deg) rotateY(${this._mx * max}deg) translate(${tx}px, ${ty}px)`;
                    });
                };

                this._onMouseLeave = () => {
                    if (this._rafId) { cancelAnimationFrame(this._rafId); this._rafId = null; }
                    this._image.style.transition = 'transform 0.6s ease';
                    this._image.style.transform = 'rotateX(0deg) rotateY(0deg)';
                    this._image.addEventListener('transitionend', () => {
                        this._image.style.transition = '';
                    }, { once: true });
                };

                this.addEventListener('mousemove', this._onMouseMove);
                this.addEventListener('mouseleave', this._onMouseLeave);
            }
        }


        handleSpotClick(spot) {
            this.querySelector('.spot[aria-selected="true"]')?.removeAttribute('aria-selected');
            spot.setAttribute('aria-selected', 'true');

            this.querySelector('.feature.active')?.classList.remove('active');
            const feature = document.getElementById(spot.getAttribute('aria-describedby'));
            if (!feature) return;
            feature.classList.add('active');

            // 手机端：滚动到对应 feature
            if (window.innerWidth < 1200) {
                feature.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }
        }

        handleFeatureClick(event) {
            this.querySelector('.spot[aria-selected="true"]')?.removeAttribute('aria-selected');
            this.querySelector(`.spot[aria-describedby="${event.currentTarget.id}"]`).setAttribute('aria-selected', 'true');

            this.querySelector('.feature.active')?.classList.remove('active');
            event.currentTarget.classList.add('active');
        }
    });
}